// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var React = require("react");
var ReactUtils = require("../../../shared/src/ReactUtils.bs.js");
var Caml_option = require("bs-platform/lib/js/caml_option.js");

function BrowserComponents_Text(Props) {
  var className = Props.className;
  var children = Props.children;
  var title = Props.title;
  var tmp = {};
  if (className !== undefined) {
    tmp.className = Caml_option.valFromOption(className);
  }
  if (title !== undefined) {
    tmp.title = Caml_option.valFromOption(title);
  }
  return React.createElement("div", tmp, React.createElement(ReactUtils.S.make, {
                  children: children
                }));
}

var make = BrowserComponents_Text;

exports.make = make;
/* react Not a pure module */
